import React, { Component } from 'react'

import { useMutation, } from '@apollo/client';
import UsernameSearch from './UsernameSearch';
import { REGISTER_TEAM } from '../../queries';


const RegisterCompetitionFormContainer = ({username, schoolType}) => {
    const [ register, { data, loading, error }] = useMutation(REGISTER_TEAM);

    return (
        <RegisterCompetitionForm
            username={username}
            competitionId={schoolType === 'UNIVERSITY' ? 1 : 2}
            register={register}
            error={error}
            loading={loading}
            data={data}/>
    );
}

class RegisterCompetitionForm extends Component {
    constructor(props) {
        super(props);
        this.competition = {
            memberCount: 3,
            id: this.props.competitionId
        }
        this.state = {
            teamName: '',
            lineId: '',
            phone: '',
            members: Array(this.competition.memberCount-1).fill(0),
            isPromo: 0,
            filePromo: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.changeMember = this.changeMember.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    handleCheckboxChange(event){
        this.setState({
            isPromo: !this.state.isPromo
        });
    }

    handleFileChange(event){
        this.setState({
            filePromo: event.target.files[0]
        });
    }

    changeMember(index, value) {
        const temp = this.state.members.map( (elm, i) => i === index ? value : elm );
        this.setState({
            members:temp
        })
    }

    isValid() {
        return !this.state.members.find(m => m < 0);
    }

    async handleSubmit(event) {
        event.preventDefault();

        const reducedMembers = this.state.members.filter(m => m!==0);

        const o = { variables: {
          teamName: this.state.teamName,
          lineId: this.state.lineId,
          phone: this.state.phone,
          members: reducedMembers,
          competitionId: this.props.competitionId,
          promo: this.state.filePromo,
        }};

        try {
          await this.props.register(o);
          window.location = '/account';
        }
        catch (e) {
        }
    }

    teamMember() {
        return (
            <>
            <p>Members</p>
            <div className="form-group">
                <input
                    className="form-control shadow-sm"
                    value={this.props.username }
                    readOnly
                />
            </div>
            { this.state.members.map( (elm, i) =>
                <UsernameSearch
                    key={i}
                    index={i}
                    changeMember={this.changeMember}
                    />
            )}
            </>)
    }

    render() {
        return (
            <div className="container">
                  <h3>Step 2 : Isi data diri</h3>
                  <hr></hr>
                  <form className="mt-5" onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <input
                            type="name"
                            className="form-control shadow-sm"
                            placeholder="Team name"
                            name="teamName"
                            value={this.state.teamName}
                            onChange={this.handleInputChange} />
                    </div>
                    <div className="form-group">
                        <input
                            className="form-control shadow-sm"
                            placeholder="Phone number"
                            name="phone"
                            value={this.state.phone}
                            onChange={this.handleInputChange} />
                    </div>

                    <div className="form-group">
                        <input
                            className="form-control shadow-sm"
                            placeholder="Line ID"
                            name="lineId"
                            value={this.state.lineId}
                            onChange={this.handleInputChange} />
                    </div>

                    <div className="form-group">
                        <h5>Menggunakan Promo?</h5>
                        <input
                            className="form-control shadow-sm"
                            placeholder="Promo"
                            type="checkbox"
                            name="isPromo"

                            onChange={this.handleCheckboxChange} />
                    </div>

                    {this.state.isPromo ?
                    <>
                    <h5 style={{
                            fontSize: "10px"
                             }}>Format masukan : .zip</h5>
                    <h5 style={{
                             fontSize: "10px"
                            }}>Max size : 1 MB</h5>
                    <div className="textbox">
                        <h5>Masukkan File Promo</h5>
                        <input
                            name="upload"
                            type="file"
                            placeholder="Masukkan File Promo"
                            onChange={this.handleFileChange}

                        />
                    </div>
                    </> : <></>
                    }
                    {this.teamMember()}
                    {this.props.error ? <p className="text-danger text-center">{this.props.error.message}</p> : <></>}
                    <button disabled={this.props.loading || !this.isValid() } className="btn btn-primary btn-block mt-3 shadow-sm" type="submit">Submit</button>
                  </form>
            </div>
        );
    }
}

export default RegisterCompetitionFormContainer;
